import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { Observable, Subject } from 'rxjs';
import { isNullOrUndefined } from 'util';

@Injectable()
export class FormValidatorService {
    private sectionPageValidate = new Subject<void>();
    private renderer: Renderer2;

    constructor(
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        rendererFactory: RendererFactory2,
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    onSectionPageValidate(): Observable<void> {
        return this.sectionPageValidate.asObservable();
    }

    validateForm(form): boolean {
        const self = this;
        const onChangeInput = function () {
            if (!this.classList.contains('.ng-invalid')) {
                self.renderer.removeClass(this, 'ValidationInputError');

                const elementValidateError: HTMLElement = document.getElementById(this.getAttribute('validate-error'));
                if (!isNullOrUndefined(elementValidateError))
                    self.renderer.removeClass(elementValidateError, 'ValidationInputError');

                this.removeEventListener('change', onChangeInput);

                const ccmPageSection: HTMLElement = this.closest('ccm-page-section');
                if (!isNullOrUndefined(ccmPageSection))
                    ccmPageSection.dispatchEvent(new Event('section-page-validate'));

                self.sectionPageValidate.next();
            }
        };

        const onKeyupInput = function () {
            if (!this.classList.contains('.ng-invalid')) {
                self.renderer.removeClass(this, 'ValidationInputError');
                const elementValidateError: HTMLElement = document.getElementById(this.getAttribute('validate-error'));
                if (!isNullOrUndefined(elementValidateError))
                    self.renderer.removeClass(elementValidateError, 'ValidationInputError');

                this.removeEventListener('keyup', onKeyupInput);

                const ccmPageSection: HTMLElement = this.closest('ccm-page-section');
                if (!isNullOrUndefined(ccmPageSection))
                    ccmPageSection.dispatchEvent(new Event('section-page-validate'));

                self.sectionPageValidate.next();
            }
        };

        this.renderer.addClass(form, 'form-touched');
        let result = true;

        if (form.classList.contains('ng-invalid-recaptcha')) return false;

        if (
            form.querySelectorAll('.ng-invalid:not(.ignore-validation)').length > 0 ||
            form.querySelectorAll('.ng-invalid.invisible-validation').length > 0
        ) {
            [...form.querySelectorAll('.ng-invalid')].forEach((element: HTMLElement) => {
                this.renderer.addClass(element, 'ValidationInputError');
                element.addEventListener('change', onChangeInput);
                element.addEventListener('keyup', onKeyupInput);
            });
            [...form.querySelectorAll('.ng-valid.invisible-validation')].forEach((element: HTMLElement) => {
                const validateErrorElement: HTMLElement = document.getElementById(
                    element.getAttribute('validate-error'),
                );
                if (!isNullOrUndefined(validateErrorElement))
                    this.renderer.removeClass(validateErrorElement, 'ValidationInputError');
            });
            [...form.querySelectorAll('.ng-invalid.invisible-validation')].forEach((element: HTMLElement) => {
                const validateErrorElement: HTMLElement = document.getElementById(
                    element.getAttribute('validate-error'),
                );
                if (!isNullOrUndefined(validateErrorElement)) {
                    this.renderer.removeClass(validateErrorElement, 'ValidationInputError');
                    this.renderer.addClass(validateErrorElement, 'ValidationInputError');
                }
            });

            result = false;
        }
        this.sectionPageValidate.next();

        return result;
    }

    showErrorMessage(message?: string): void {
        this.fiDialogsService.notify({
            messageText: message || this.appTextService.get('common.error_all_mandatory'),
            headerText: this.appTextService.get('common.warning'),
        });
    }
}
